<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar></navbar>
			<!--导航-->
			<!--banner-->
			<div class="banner_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="txt">Search Results for:</div>
				<div class="tit">
					{{ searchVal }}
				</div>
				<div class="txt">Find what you're looking for</div>
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1">
				<div class="title"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>Total: {{ total }} results</div>
				<div v-if="searchData.length > 0" v-loading="searchLoading" class="list_box">
					<div
						v-for="(value, index) in searchData"
						:key="index"
						class="list_el"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						@click="goInfo(value)"
					>
						<div class="tips">{{ value.leixing }}</div>
						<div class="tit">{{ value.title }}</div>
						<div v-if="value.content" class="txt">{{ value.content }}</div>
					</div>
				</div>
				<div v-else style="padding: 20px 0;color: #999999;text-align: center;">
					<!-- Sorry, but nothing matched your search terms. -->
					<img src="../../assets/img/search_no.png" />
				</div>
				<div v-if="searchData.length > 0 && isLoadAll" class="btn_box_more" @click="pageAdd">
					Load More
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="txt">Didn't Find What You Are Looking For?</div>
				<div class="tit">Search Again</div>
				<div class="input_box">
					<input v-model="searchVal" @keyup.enter="searchClick" />
					<div class="btn_box" @click="searchClick">
						<van-icon name="search" size="20px" color="#ffffff" style="position: relative;top: 3px;font-weight: bold;" />
					</div>
				</div>
			</div>
			<!--块2-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import fixed from '@/component/pc/fixed.vue'  //联系我们悬浮
import { searchList } from '@/api/public';
export default {
	components:{
		navbar,
		footerBox,
		fixed,
	},
	data() {
		return {
			isLoading: true,  //界面loading
			searchVal: '',
			searchData: [],
			total: 0,
			noPage: 1,
			searchLoading: false,
			searchPending: false,
			searchRequestId: 0,
			isLoadAll: true,
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		if(sessionStorage.getItem('searchVal')) {
			that.searchVal = sessionStorage.getItem('searchVal');
			document.title = sessionStorage.getItem('searchVal') + ' - CorDx';
			that.getSearchList();
		}else {
			document.title = 'Search - CorDx';
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		goInfo(value) {
			let that = this;
			let pathUrl = '';
			let unionid = '';
			switch (value.leixing){
				case 'Products': // flu-a%2Fb-&-covid-19-multiplex-rapid-test cordx-tyfast-flu-a/b-&-covid-19-multiplex-rapid-test
					if(value.custom == 'flu-a/b-&-covid-19-multiplex-rapid-test') {
						let routeData1 = that.$router.resolve({name: "Productsinfos", params: { productInfoIds: value.custom } });
						window.open(routeData1.href, '_blank');
					}else if(value.custom == 'cordx-tyfast-flu-a-b-covid-19-at-home-rapid-multiplex-test-cordx') {
						let routeData3 = that.$router.resolve({name: "Productsinfos2", params: { productInfoIds: value.custom } });
						window.open(routeData3.href, '_blank');
					}else if(value.custom == 'cordx-tyfast-covid-19-ag-rapid-test') {
						let routeData4 = that.$router.resolve({name: "Productsinfos3", params: { productInfoIds: value.custom } });
						window.open(routeData4.href, '_blank');
					}else if(value.custom == 'cordx-tyfast-multi-drug-rapid-test-cup') {
						let routeData5 = that.$router.resolve({name: "cordx-tyfast-multi-drug-rapid-test-cup" });
						window.open(routeData5.href, '_blank');
					}else if(value.custom == 'cordx-tyfast-rsv-rapid-test') {
						let routeData6 = that.$router.resolve({name: "cordx-tyfast-rsv-rapid-test" });
						window.open(routeData6.href, '_blank');
					}else if(value.custom == 'cordx-tyfast-ovulation-test-pregnancy-test-combo') {
						let routeData7 = that.$router.resolve({name: "cordx-tyfast-ovulation-test-pregnancy-test-combo" });
						window.open(routeData7.href, '_blank');
					}else if(value.custom == 'cordx-one-step-hcg-pregnancy-test-cassette') {
						let routeData8 = that.$router.resolve({name: "cordx-one-step-hcg-pregnancy-test-cassette" });
						window.open(routeData8.href, '_blank');
					}else if(value.custom == 'cordx-tyfast-cotinine-cot-rapid-test') {
						let routeData9 = that.$router.resolve({name: "cordx-tyfast-cotinine-cot-rapid-test" });
						window.open(routeData9.href, '_blank');
					}else if(value.custom == 'cordx-tyfast-fsh-rapid-test') {
						let routeData10 = that.$router.resolve({name: "cordx-tyfast-fsh-rapid-test" });
						window.open(routeData10.href, '_blank');
					}else if(value.custom == 'cordx-tyfast-flu-a-b-covid-19-multiplex-rapid-test-otc') {
						let routeData11 = that.$router.resolve({name: "cordx-tyfast-flu-a-b-covid-19-multiplex-rapid-test-otc" });
						window.open(routeData11.href, '_blank');
					}else {
						let routeData2 = that.$router.resolve({name: "Productsinfo", params: { productInfoId: value.custom } });
						window.open(routeData2.href, '_blank');
					}
					break;
				case 'Events':
					let routeData2 = that.$router.resolve({name: "Eventsinfo", params: { eventsInfoId: value.custom } });
					window.open(routeData2.href, '_blank');
					break;
				default:
					let routeData3 = that.$router.resolve({name: "Resourcesinfo", params: { resourcesInfoId: value.custom } });
					window.open(routeData3.href, '_blank');
					break;
			}
		},
		//翻页
		pageAdd() {
			if (this.searchPending) return;
			let that = this;
			that.noPage = that.noPage + 1;
			that.getSearchList();
		},
		//点击搜索岗位
		searchClick() {
			this.total = 0;
			let that = this;
			that.noPage = 1;
			that.searchData = [];
			that.isLoadAll = true;
			that.getSearchList();
			window.scroll(0, 0);
		},
		//请求搜索列表
		getSearchList() {
			let that = this;
			const requestId = ++that.searchRequestId;
			const page = that.noPage;
			that.searchPending = true;
			that.searchLoading = true;
			return searchList({
				keyword: that.searchVal,
				page,
				page_size: 6,
				language: sessionStorage.getItem('lang'),
			}).then(res => {
				if (requestId !== that.searchRequestId || that._isDestroyed) return;
				that.searchData = [...that.searchData, ...res.data.data];
				that.total = res.data.total;
				that.isLoadAll = res.data.data.length >= 6;
			}).catch(() => {
				if (requestId !== that.searchRequestId || that._isDestroyed) return;
				// A failed page must be retried instead of skipped.
				that.noPage = Math.max(1, page - 1);
			}).then(() => {
				if (requestId !== that.searchRequestId || that._isDestroyed) return;
				that.searchPending = false;
				that.searchLoading = false;
			});
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	/*块2*/
	.block_2{
		width: 1140px;
		margin: 0 auto;
		padding: 100px 0;
		text-align: center;
		.input_box{
			.btn_box{
				margin-left: 30px;
				padding: 4px 20px;
				border-radius: 18px;
				background-color: #0066D4;
				display: inline-block;
				cursor: pointer;
			}
			input{
				width: 685px;
				height: 45px;
				line-height: 45px;
				border: 1px solid #EFEFEF;
				background-color: #ffffff;
				text-indent: 20px;
				font-size: 20px;
				color: #0B318F;
			}
		}
		.tit{
			padding: 10px 0 40px 0;
			font-size: 50px;
			color: #0B318F;
		}
		.txt{
			color: #999999;
		}
	}
	/*块1*/
	.block_1{
		width: 1140px;
		margin: 0 auto;
		padding: 80px 0;
		border-bottom: 1px solid #EFEFEF;
		.list_box{
			.list_el{
				display: inline-block;
				width: 46%;
				margin: 40px 2% 0 2%;
				cursor: pointer;
				.txt{
					font-size: 16px;
					color: #706B69;
				}
				.tit{
					padding: 20px 0 10px 0;
					font-size: 22px;
				}
				.tips{
					display: inline-block;
					padding: 8px 24px 4px 24px;
					border-radius: 22px;
					background-color: #EFEFEF;
					color: #0B318F;
					font-size: 16px;
				}
			}
		}
		.title{
			font-size: 18px;
		}
	}
	/*轮播*/
	.banner_box{
		width: 100%;
		background-color: #FBFAFF;
		padding: 50px 0;
		text-align: center;
		.txt{
			padding: 10px 0;
			font-size: 30px;
			color: #706B69;
		}
		.tit{
			width: 1140px;
			margin: 0 auto;
			font-size: 50px;
		}
	}
	/*按钮*/
	.btn_box_more{
		display: inline-block;
		padding: 0 28px;
		height: 42px;
		line-height: 42px;
		font-size: 20px;
		color: #0B318F;
		background: #FFFFFF;
		border-radius: 22px 22px 22px 22px;
		border: 1px solid #0B318F;
		text-align: center;
		cursor: pointer;
		margin: 55px 0 0 43%;
		img{
			width: 20px;
			position: relative;
			top: 10px;
			left: 10px;
			transition: all 0.3s;
		}
	}
	.btn_box_more:hover{
		img{
			transform: translateX(6px);
		}
		background-color: #f5f8fa;
	}
}
</style>
